import React, { useState, Suspense, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import FigoLoadingOverlay from '../../../common/FigoLoadingOverlay';
import { FILES_TYPES_ACCEPTED } from '../../../../constants';
import { FileViewerError } from './FileViewerError';

import './FileViewer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${
  pdfjs.version}/build/pdf.worker.min.js`;

const FileViewer = ({
  customErrorComponent = null,
  filePath = '',
  fileType = 'pdf',
  fileViewerKey = 'Inbox&DocsFileViewer',
}) => {
  const isPDF = fileType === FILES_TYPES_ACCEPTED.pdf.split('.')[1];
  const [pages, setPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setPages(numPages);
  }

  const renderPDF = useCallback(() => (
    <Document
      key={fileViewerKey}
      error={customErrorComponent || <FileViewerError />}
      file={filePath}
      loading={<FigoLoadingOverlay visible />}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.from(new Array(pages), (el, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          renderAnnotationLayer={false}
          renderTextLayer={false}
        />
      ))}
    </Document>
  ), [fileViewerKey, customErrorComponent, filePath, pages]);

  function renderImages() {
    const imageStyle = filePath ? 'File-viewer-image'
      : 'File-viewer-error-container';

    return (
      <img
        alt="file-viewer"
        className={imageStyle}
        src={filePath}
      />
    );
  }

  return (
    <div className="File-viewer-container-multibrand">
      <Suspense fallback={<FigoLoadingOverlay visible />}>
        {isPDF ? renderPDF() : renderImages()}
      </Suspense>
    </div>
  );
};

export { FileViewer };
